module.exports = __webpack_public_path__ + "static/img/icon3.28ca5dd2.png";